var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33496 3.23925C1.33496 2.71349 1.76134 2.28711 2.2871 2.28711H13.7128C14.2395 2.28711 14.665 2.71349 14.665 3.23925C14.665 3.76591 14.2395 4.1914 13.7128 4.1914H2.2871C1.76134 4.1914 1.33496 3.76591 1.33496 3.23925ZM1.33496 7.99997C1.33496 7.47331 1.76134 7.04782 2.2871 7.04782H13.7128C14.2395 7.04782 14.665 7.47331 14.665 7.99997C14.665 8.52662 14.2395 8.95211 13.7128 8.95211H2.2871C1.76134 8.95211 1.33496 8.52662 1.33496 7.99997ZM13.7128 13.7128H2.2871C1.76134 13.7128 1.33496 13.2873 1.33496 12.7607C1.33496 12.234 1.76134 11.8085 2.2871 11.8085H13.7128C14.2395 11.8085 14.665 12.234 14.665 12.7607C14.665 13.2873 14.2395 13.7128 13.7128 13.7128Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1f660849e2ca2f2b83ee2a4718861fd4.svg";
export { ForwardRef as ReactComponent };